export default __webpack_public_path__ + "static/media/switch.7780d25d.svg";